import clsx from 'clsx';
import { errorToString } from 'helpers/error-helpers';
import React from 'react';
import styles from './Loading.module.scss';

import animationData from 'assets/animations/loader_small.json';
import { LottieContainer } from '../../animations/LottieContainer.tsx';

type Props = {
  loading: boolean;
  title?: string;
  testId?: string;
  children?: React.ReactNode;
  className?: string;
  flex?: boolean;
  error?: any;
  wrapperClassName?: string;
  centerContent?: boolean;
  textClassName?: string;
};

export const Loading: React.FC<Props> = (props) => {
  const loadingStyles = [props.className];
  loadingStyles.push(styles.loadingContainer);

  return (
    <div
      className={clsx(
        props.flex ? styles.flexContainer : styles.container,
        props.centerContent !== false ? styles.centerContent : null,
        props.wrapperClassName,
      )}
      data-test-id={props.testId}
    >
      <div
        data-loaded={props.loading}
        className={props.flex ? styles.flexLoadingData : styles.loadingData}
      >
        {props.error ? (
          <h1 className={styles.loading} data-test-id="loading-error">
            {errorToString(props.error)}
          </h1>
        ) : (
          props.children
        )}
      </div>
      {props.loading && !props.error && (
        <div className={clsx(loadingStyles)} data-test-id="loading">
          <div className={styles.loading}>
            <LottieContainer
              animationData={animationData}
              className={styles.lottie}
            />
            {props.title && (
              <div className={clsx(styles.title, props.textClassName)}>
                {props.title}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
